import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import configureStore from './configureStore';

// import Mock from './containers/tree/fan';
// import Mock from './containers/tree/clockHand';
// import Mock from './containers/tree/textCircle';
// import Mock from './containers/mock/Fan';
// import Mock from './containers/mock/mock2';
// import Mock from './containers/mock/mock4';
// import Fan from './components/FanChart';


import Tree from './containers/tree';
// import reportWebVitals from './reportWebVitals';
import {
  isMobilePhone,
} from './library/calc';
// import dynamicallyLoadFontsForDesktop from './loader/dynamicallyLoadFontsForDesktop';
// import dynamicallyLoadTreeActivationBannerForDesktop from './loader/dynamicallyLoadTreeActivationBannerForDesktop';
// import dynamicallyLoadExpiringProUpsellForDesktop from './loader/dynamicallyLoadExpiringProUpsellForDesktop';
// import dynamicallyLoadActiveNotificationForDesktop from './loader/dynamicallyLoadActiveNotificationForDesktop';
import dynamicallyLoadCssForMobilePhone from './loader/dynamicallyLoadCssForMobilePhone';
import dynamicallyLoadCssForDesktop from './loader/dynamicallyLoadCssForDesktop';
import './index.css';

const initialState = {};
const store = configureStore(initialState);

const root = ReactDOM.createRoot(document.getElementById('app'));

// const focusPerson = { id: '1', name: 'John Doe' };

// const data = [
//   { id: '1', name: 'John Doe', parentId: null },
//   { id: '2', name: 'Jane Doe', parentId: '1', gender: 'female', level: 1, direction: 0 },
//   { id: '3', name: 'Michael Smith', parentId: '1', gender: 'male', level: 1, direction: 1 },
//   { id: '4', name: 'Linda Johnson', parentId: '2', gender: 'female', level: 2, direction: 0 },
//   { id: '5', name: 'Deborah Brown', parentId: '2', gender: 'female', level: 2, direction: 1 },
//   { id: '6', name: 'James Williams', parentId: '3', gender: 'male', level: 2, direction: 2 },
//   { id: '7', name: 'Richard Jones', parentId: '3', gender: 'male', level: 2, direction: 3 },
// ];

root.render(
    <Provider store={store}>
      <Tree />
    </Provider>
);

if(isMobilePhone()) dynamicallyLoadCssForMobilePhone();
else{
  dynamicallyLoadCssForDesktop();
  // dynamicallyLoadTreeActivationBannerForDesktop();
}
/*
  <React.StrictMode>
      <Tree />
  </React.StrictMode>
 */
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


